import React, { useState, useEffect } from "react";
import { ArrowSmRightIcon } from "@heroicons/react/outline";
import Icon from "../../Component/MySkills/Icon"

import ContactHomePage from "./ContactHomePage";
import Tab from "../Tabs/Tab"
const Experience = () => {
        
          const [panel, setPanel] = useState()
          useEffect(() => {
           
            setPanel(1)
          }, []);
         

  const pageRedirect = () => {
    window.open(
      "https://www.tcs.com/service-desk-support-transformation-improve-cx#:~:text=TCS%20Solution,grade%20experience%20for%20enterprise%20support.",
      "_blank"
    );
  };
  const startDate = new Date(2021, 3, 8); // april 8th 2021
  const endDate = new Date(); // April 18th 2022
  const monthDiff =
    endDate.getMonth() -
    startDate.getMonth() +
    12 * (endDate.getFullYear() - startDate.getFullYear());
    const PanelRender = (data) => {
      setPanel(data)
    }
  return (
    <center>
      <h3 className={" font-bol text-[32px] dark:text-[#FFF] "}>
        Experience
      </h3>
      <div className="horizontal"></div>
      <Tab panel1={"Professional"} panel2={"Project"} panelData={PanelRender} />
      <div>
       { panel===1&&<div className="mt-12 flex  flex-col  justify-center lg:w-[80%] lg:flex-row">
          <div className="border-[2px] border-[#17A6DB] dark:border-[#30dada] lg:w-[40%] my-4 ">
                    <div className="mt-4 mb-4">
          <Icon iconType={"React"} /></div>
            
            <h3 className="text-[32px] font-bold text-[#17A6DB] dark:text-[#30dada]  ">
              {" "}
              REACT DEVELOPER
            </h3>
            <div className="horizontal1"></div>
            <h2 className="mt-2 text-[16px] font-bold dark:text-white">
              {" "}
              2021-Present{" "}
            </h2>
            <h3 className="text-[24px] font-bold text-[#17A6DB] dark:text-[#30dada]">
              TCS l Bengaluru , India
            </h3>
            <p className="w-[80%]  text-[16px] dark:text-white">
              I am a qualified and professional Frontend developer with{" "}
              <span className="text-[#17A6DB] dark:text-[#30dada] font-bold"> {monthDiff}</span> month of experience in website development. Strong
              creative and analytical skills. Team player with an eye for
              detail.
            </p>
          </div>
          <div className="border-[2px] border-[#17A6DB] my-4 lg:ml-8 dark:border-[#30dada] lg:w-[50%]">
            <h3 className="text-[32px] font-bold text-[#17A6DB] dark:text-[#30dada]">
              {" "}
              Project Experience{" "}
            </h3>
            <div className="horizontal1"></div>
            <h2 className="text-[24px] font-bold dark:text-white">
              {" "}
              1.ChatBot Solution{" "}
            </h2>
            <p className="w-[80%]  text-[16px] dark:text-white">
              {" "}
              It is solution leverages artificial intelligence (AI) and natural
              language processing(NLP) to offer a consumer-grade experience for
              enterprise support. Through an intelligent , predictive ,
              suggestive and contextual model (IPSC), the solution drives
              contextualization and personalization at scale and predict users
              support needs.
            </p>
            <p
              className="flex text-[24px] cursor-pointer font-bold text-[#17A6DB] dark:text-[#30dada] ml-4"
              onClick={pageRedirect}
            >
              {" "}
              ChatBot Solution Url.
              <ArrowSmRightIcon className="ml-2 w-5" />{" "}
            </p>
            <h2 className="text-[24px] font-bold dark:text-white">
              {" "}
              2 .ChatBot Solution ANAYTICS DASHBOARD
            </h2>
            <p className="w-[80%]  text-[16px] dark:text-white">
              {" "}
              This is data analytics platform works by supporting data intensive
              applications and could simultaneously support the clusters of
              hardware. They work by using a set of general primitives in order
              to perform the analysis on a real-time basis.
            </p>
          </div>
        </div>}
        {panel===2&& <div className="border-[2px] border-[#17A6DB] my-4 lg:ml-8 dark:border-[#30dada] lg:w-[50%]">
            <h3 className="text-[32px] font-bold text-[#17A6DB] dark:text-[#30dada]">
            I will be updating soon 😊.
            </h3>
            </div>
}
       <div className=" mt-[100px] ">
       <ContactHomePage/>
       </div> 
      
      </div>
    </center>
  );
};

export default Experience;
